import Excel from 'exceljs';

import { Time } from '@/common/models/Time';

export class ExcelParser {
  public static parseRaw(cell: Excel.Cell) {
    return cell.formula ? cell.result : cell.value;
  }

  public static parseNumber(cell: Excel.Cell): number {
    const rawValue = this.parseRaw(cell);
    const valueString = rawValue?.toString();
    return valueString ? +valueString : null;
  }

  public static parseString(cell: Excel.Cell): string {
    const rawValue = this.parseRaw(cell);
    return rawValue?.toString();
  }

  public static parseBoolean(cell: Excel.Cell): boolean {
    const rawValue = this.parseRaw(cell);
    const formattedValue = rawValue?.toString().toLowerCase();
    if (formattedValue == null) {
      return null;
    }
    return formattedValue === 'true' || formattedValue === '1';
  }

  public static parseTime(cell: Excel.Cell): Time {
    const rawValue = this.parseRaw(cell);
    if (rawValue == null) {
      return null;
    }
    if (cell.type === Excel.ValueType.Number) {
      // If the cell contains a time value as a number
      const excelTime = rawValue as number; // Fractional day
      if (excelTime == null) {
        return null;
      }
      const totalSeconds = Math.round(excelTime * 24 * 60 * 60);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      return Time.fromObject({
        hours,
        minutes,
        seconds,
      });
    } else if (cell.type === Excel.ValueType.Date) {
      // If the cell contains a date (including time)
      const date = rawValue as Date;
      return Time.fromObject({
        hours: date.getUTCHours(),
        minutes: date.getUTCMinutes(),
        seconds: date.getUTCSeconds(),
      });
    } else {
      throw new Error('Invalid cell type');
    }
  }
}
